const nevadaHubFAQs = [
  {
    question: "Who is a licensed life insurance agent near me in Nevada?",
    answer: "Kenneth Carson is a licensed Comparion Insurance (Liberty Mutual affiliate) agent licensed in Nevada, California, and Hawaii. He serves Las Vegas, Henderson, North Las Vegas, Summerlin, Reno, Sparks, and Carson City families through phone and video consultations, with a 5.0-star rating from 74 reviews. Call (916) 505-1000."
  },
  {
    question: "Can I buy life insurance from an agent whose office isn't in Nevada?",
    answer: "Yes. What matters is that the agent holds an active Nevada insurance license. Kenneth Carson is licensed in Nevada and handles quotes, applications, and policy reviews by phone, video, and e-signature — and he works in the same Pacific time zone."
  },
  {
    question: "How much does life insurance cost in Nevada?",
    answer: "Rates depend on your age, health, tobacco use, coverage amount, and term length. A healthy 35-year-old can often get a 20-year, $500,000 term policy for less than a monthly streaming bundle. Kenneth can compare options and give you a free, no-obligation quote."
  },
  {
    question: "What type of life insurance is best for Nevada families?",
    answer: "Most working families start with term life (10, 20, or 30 years) to cover the mortgage, kids' education, and income replacement. Business owners and people focused on estate planning often add whole life or universal life for permanent coverage and cash value."
  },
  {
    question: "Does Kenneth Carson work with hospitality and casino workers?",
    answer: "Yes. Many Las Vegas and Reno residents work in gaming, hospitality, and entertainment, where group life coverage is often limited to one or two times salary. Kenneth helps them add affordable individual coverage that stays with them if they change jobs."
  }
];

const nevadaRelatedPosts = [
  { slug: "life-insurance-agent-nevada-guide", title: "Life Insurance Agent Nevada — Straight Talk About Protecting Your Family" }
];

const nevadaCities = [
  {
    slug: "las-vegas",
    name: "Las Vegas",
    area: "Clark County",
    zip: "89101",
    geo: { latitude: 36.1716, longitude: -115.1391 },
    image: "https://images.unsplash.com/photo-1668261929011-4ade8c225292?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600",
    metaTitle: "Life Insurance Agent Near Me Las Vegas, NV | Kenneth Carson",
    metaDescription: "Looking for a life insurance agent near me in Las Vegas, NV? Kenneth Carson, licensed in Nevada, offers free term, whole & universal life quotes. 5.0★ (74 reviews).",
    headline: "Life Insurance Agent Near Me in Las Vegas, Nevada",
    intro: "Las Vegas never sleeps — and neither do a lot of the people who keep it running. Whether you work a swing shift on the Strip, serve at Nellis Air Force Base, teach in CCSD, or run your own business in Summerlin, your family depends on your income. I'm Kenneth Carson, a Nevada-licensed Comparion agent, and I help Las Vegas families get life insurance that actually fits their lives.",
    neighborhoods: ["Summerlin", "Spring Valley", "Enterprise", "Paradise", "Southwest Las Vegas", "Centennial Hills", "North Las Vegas", "Aliante", "Mountains Edge", "Downtown Las Vegas"],
    localNeeds: [
      { title: "Hospitality & gaming workers", text: "Tip-based or shift income? Affordable term coverage protects your family without straining the budget." },
      { title: "Nellis AFB & Creech families", text: "Add private coverage on top of SGLI that stays with you after you leave the service." },
      { title: "Growing households", text: "New homes and young kids mean a 20- or 30-year term policy can lock in low rates for decades." }
    ],
    faqs: [
      {
        question: "Who is the best life insurance agent near me in Las Vegas?",
        answer: "Kenneth Carson is a Nevada-licensed Comparion Insurance agent with a 5.0-star rating from 74 reviews who serves Las Vegas, Summerlin, Spring Valley, Enterprise, and North Las Vegas. He offers free phone and video consultations for term, whole, and universal life insurance. Call (916) 505-1000."
      },
      {
        question: "Can casino and hotel workers get life insurance in Las Vegas?",
        answer: "Yes. Insurers look at your overall income and health, not your industry. Many hospitality workers have limited group coverage, so an individual term policy is a smart, affordable way to protect their families."
      },
      {
        question: "How much life insurance do I need in Las Vegas?",
        answer: "A common starting point is 10–12 times your annual income plus your remaining mortgage balance, debts, and expected college costs. Kenneth will walk through your numbers for free."
      },
      {
        question: "Do I need a medical exam for life insurance in Las Vegas?",
        answer: "Not always. Depending on your age, health, and coverage amount, some policies offer accelerated underwriting with no medical exam. Kenneth can tell you which options you may qualify for."
      }
    ]
  },
  {
    slug: "henderson",
    name: "Henderson",
    area: "Clark County",
    zip: "89002",
    geo: { latitude: 36.0395, longitude: -114.9817 },
    image: "https://images.pexels.com/photos/16601069/pexels-photo-16601069.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Life Insurance Agent Near Me Henderson, NV | Kenneth Carson",
    metaDescription: "Need a life insurance agent near me in Henderson, NV? Kenneth Carson, licensed in Nevada, serves Green Valley, Anthem & Inspirada families with free quotes. 5.0★ (74 reviews).",
    headline: "Life Insurance Agent Near Me in Henderson, Nevada",
    intro: "Henderson is where a lot of Southern Nevada families put down roots — great schools, master-planned neighborhoods, and parks on every corner. If you've just bought a home in Inspirada or Cadence, or you've been in Green Valley for twenty years, life insurance is how you make sure your family can stay put no matter what. I'm Kenneth Carson, a Nevada-licensed Comparion agent, and I make getting covered simple.",
    neighborhoods: ["Green Valley", "Anthem", "Seven Hills", "Inspirada", "Cadence", "MacDonald Ranch", "Lake Las Vegas", "Whitney Ranch", "Silverado Ranch", "Boulder City"],
    localNeeds: [
      { title: "New mortgages", text: "Newer master-planned communities mean larger loan balances — term life sized to the mortgage keeps the home safe." },
      { title: "Young families", text: "Lock in low rates while you're young and healthy, and cover the years your kids depend on you." },
      { title: "Retirees & legacy planning", text: "Permanent and final expense policies help cover costs and leave something for the grandkids." }
    ],
    faqs: [
      {
        question: "Is there a life insurance agent near me in Henderson, NV?",
        answer: "Yes. Kenneth Carson is a Nevada-licensed Comparion Insurance agent who serves Henderson, Green Valley, Anthem, Seven Hills, Inspirada, Cadence, and Boulder City through phone and video consultations. He has a 5.0-star rating from 74 reviews. Call (916) 505-1000."
      },
      {
        question: "When should a Henderson family buy life insurance?",
        answer: "The best times are when you buy a home, get married, or have a child. Rates are lowest when you're young and healthy, and a 20- or 30-year term can lock in that price for decades."
      },
      {
        question: "Is my employer's life insurance enough?",
        answer: "Usually not. Group coverage is often only 1–2 times your salary and may end if you change jobs. An individual policy stays with you no matter where you work."
      },
      {
        question: "How do I get a free life insurance quote in Henderson?",
        answer: "Call Kenneth at (916) 505-1000, email Kenneth.Carson@Comparion.com, or fill out the quote form on this page. Consultations are free and there's no obligation."
      }
    ]
  },
  {
    slug: "reno",
    name: "Reno",
    area: "Washoe County",
    zip: "89501",
    geo: { latitude: 39.5296, longitude: -119.8138 },
    image: "https://images.pexels.com/photos/36773728/pexels-photo-36773728.jpeg?auto=compress&cs=tinysrgb&w=1600",
    metaTitle: "Life Insurance Agent Near Me Reno, NV | Sparks & Carson City",
    metaDescription: "Searching for a life insurance agent near me in Reno, Sparks or Carson City? Kenneth Carson, licensed in Nevada, offers free life insurance quotes. 5.0★ (74 reviews).",
    headline: "Life Insurance Agent Near Me in Reno, Nevada",
    intro: "Reno has changed fast. New jobs at the Tahoe-Reno Industrial Center, a growing tech scene, UNR, and new neighborhoods from South Meadows to Spanish Springs have brought a lot of young families to Northern Nevada. I'm Kenneth Carson, a Nevada-licensed Comparion agent, and I help Reno, Sparks, and Carson City families protect the life they're building.",
    neighborhoods: ["Downtown Reno", "Midtown", "South Meadows", "Somersett", "Damonte Ranch", "Sparks", "Spanish Springs", "Sun Valley", "Carson City", "Washoe Valley"],
    localNeeds: [
      { title: "Tech & manufacturing workers", text: "New jobs often come with basic group coverage — an individual policy goes with you if you change employers." },
      { title: "First-time homebuyers", text: "Rising Reno home prices mean bigger mortgages worth protecting with term life." },
      { title: "Business owners", text: "Protect partners and key people with buy-sell or key person life insurance." }
    ],
    faqs: [
      {
        question: "Who is a life insurance agent near me in Reno, NV?",
        answer: "Kenneth Carson is a Nevada-licensed Comparion Insurance agent serving Reno, Sparks, Spanish Springs, Damonte Ranch, Somersett, and Carson City with free phone and video consultations. He holds a 5.0-star rating from 74 reviews. Call (916) 505-1000."
      },
      {
        question: "Is life insurance more expensive in Reno than in Las Vegas?",
        answer: "No. Life insurance rates are driven by age, health, tobacco use, and coverage amount — not by which Nevada city you live in. Reno residents get the same rates available statewide."
      },
      {
        question: "Should I get life insurance if I just moved to Reno for work?",
        answer: "It's a great time to. If you've relocated and bought a home, a term policy protects your family and your mortgage, and it stays with you even if you change jobs."
      },
      {
        question: "Can I get a Reno life insurance quote without meeting in person?",
        answer: "Yes. Kenneth handles quotes, applications, and policy reviews by phone, video, and e-signature. He's on Pacific Time, just like you."
      }
    ]
  }
];

export const nevadaRegion = {
  key: "nevada",
  stateName: "Nevada",
  abbr: "NV",
  basePath: "/nevada",
  hubImage: "https://images.unsplash.com/photo-1685502659945-721d57e46b4d?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=1600",
  hubImageAlt: "Desert road through Red Rock Canyon, Nevada",
  hubBadge: "Las Vegas · Henderson · Reno · Carson City",
  hubMetaTitle: "Life Insurance Agent Near Me Nevada | Las Vegas, Henderson, Reno",
  hubMetaDescription: "Nevada-licensed life insurance agent Kenneth Carson serves Las Vegas, Henderson, Reno, Sparks & Carson City. Free term, whole & universal life quotes. 5.0★ from 74 reviews.",
  hubIntro: "Nevada-licensed Comparion agent Kenneth Carson helps Silver State families protect what matters with honest, no-pressure life insurance advice — by phone or video, statewide.",
  hoursLabel: "Same time zone as you",
  hoursNote: "Office hours are Monday–Friday, 8:30 AM–5:00 PM Pacific Time — the same time zone as Las Vegas, Henderson, and Reno. Phone and video appointments are available statewide.",
  relatedPosts: nevadaRelatedPosts,
  hubFaqs: nevadaHubFAQs,
  cities: nevadaCities
};
